module.exports = __webpack_public_path__ + "img/image149.92d2322c.jpg";